// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Skeleton, Stack, Typography } from '@mui/material';

/**
 * A skeleton loading state for the ItemBOMForm component.
 * Displays placeholder elements while the actual data is loading.
 */
export function ItemBOMFormSkeleton() {
  return (
    <Stack spacing={2}>
      <Typography variant="subtitle1">Bill of materials</Typography>
      <Skeleton variant="text" width={300} height={48} />
      <Skeleton variant="text" width={300} height={48} />
      <Skeleton variant="text" width={300} height={48} />
      <Skeleton variant="text" width={120} height={36} />
    </Stack>
  );
}
